export default __webpack_public_path__ + "static/media/hyundai.6185a8c1.png";